export default "__VITE_ASSET__DBwcciVU__"